import { useTranslation } from 'react-i18next';
import { useModal } from 'context/ModalContext';
import { getButtonsNoYesDanger } from 'context/helpers/helperModalContext';
import SvgTrash from 'components/svg/SvgTrash';

const useDeleteClient = () => {
    const { t } = useTranslation(['Clients']);
    const { showDlg } = useModal();

    const paramsDelDlg = {
        buttons: [...getButtonsNoYesDanger(t)],
        type: 'confirm',
    };

    const deleteClient = (client: any, cbFunct: () => void) => {
        const p: any = {
            ...paramsDelDlg,
            text: (
                <>
                    <h4 className="d-flex pb-2 mb-2 border-bottom text-danger">
                        <SvgTrash className="text-danger" />
                        <span className="ps-2">{t('clientPopup.delete')}?</span>
                    </h4>
                    <h5 className="mb-0">{client.clientName}</h5>
                    <small className="form-text text-muted">{client.clientPhone}</small>
                </>
            ),
        };

        p.buttons[1].handleClick = () => {
            showDlg(false);
            cbFunct();
        };
        showDlg(p);
    };

    return {
        deleteClient,
    };
};

export default useDeleteClient;
